/**
 * useProfilePhotos Hook
 * Custom hook for fetching all profile photos
 */

import { useQuery } from "@tanstack/react-query"
import apiClient from "@/lib/api-client"

export async function getProfilePhotos(userId: string) {
  const { data } = await apiClient.get(`api/profiles/${userId}/photos`)
  return data.data.photos
}

export function useProfilePhotos(userId: string) {
  return useQuery({
    queryKey: ["photos", userId],
    queryFn: () => getProfilePhotos(userId),
    enabled: !!userId,
  })
}
